const STARS = Array.from({ length: 12 }, (_, i) => {
  const a = (i * Math.PI) / 6;
  return [30 + 12 * Math.sin(a), 20 - 12 * Math.cos(a)];
});

export const TrFlag = ({ className = "" }) => (
  <svg viewBox="0 0 60 40" className={className} aria-label="Türk bayrağı" data-testid="flag-tr">
    <rect width="60" height="40" rx="4" fill="#E30A17" />
    <circle cx="22" cy="20" r="10" fill="#fff" />
    <circle cx="24.5" cy="20" r="8" fill="#E30A17" />
    <polygon fill="#fff" points="33,20 39.5,17.9 35.5,23.4 35.5,16.6 39.5,22.1" />
  </svg>
);

export const EuFlag = ({ className = "" }) => (
  <svg viewBox="0 0 60 40" className={className} aria-label="Avrupa Birliği bayrağı" data-testid="flag-eu">
    <rect width="60" height="40" rx="4" fill="#003399" />
    {STARS.map(([x, y], i) => (
      <polygon key={i} fill="#FFCC00" transform={`translate(${x} ${y}) scale(2.8)`}
        points="0,-1 0.29,-0.4 0.95,-0.31 0.48,0.15 0.59,0.81 0,0.5 -0.59,0.81 -0.48,0.15 -0.95,-0.31 -0.29,-0.4" />
    ))}
  </svg>
);
